import { render, staticRenderFns } from "./SessionFlags.vue?vue&type=template&id=58b06759&scoped=true&"
import script from "./SessionFlags.vue?vue&type=script&lang=js&"
export * from "./SessionFlags.vue?vue&type=script&lang=js&"
import style0 from "./SessionFlags.vue?vue&type=style&index=0&id=58b06759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b06759",
  null
  
)

export default component.exports